
import KpBottomBtn from '@/plugin/bottombtn'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

import {corpList} from '@/controller/corp'

export default {
data() {
return {
account: {
phone: '',
email: ''
},
corpList: [],
isContinue: true
}
},
created() {
corpList({
callback: res => {
this.corpList = res.data
if (!res.data) {
this.$router.push('/register')
}
}
})
},
methods: {},
components: {
KpBottomBtn,
XHeader,
Group,
Cell,
Panel,
Confirm,
CellBox
}
}



// WEBPACK FOOTER //
// ./src/components/corpList.vue